import React from "react";
import { RouteObject } from "../../interfaces/navigation";
import CongratulationsPage from "./CongratulationsPage";

export const congratulationsRoutes: RouteObject[] = [
    {
        title: "CongratulationsPage",
        path: "/agradecimiento", 
        component: <CongratulationsPage title={""} text={""} />
    }
];